import { Subscriber }  from 'rxjs';
import App from '../app';

export default class HttpSubscriber extends Subscriber {
  constructor(observer, requestConfiguration) {
    super(observer);

    this.store = App.getStore();

    this.requestId = Math.random() + '-xhr-abort-id';
    this.aborted = false;

    App.axios({...requestConfiguration, ...{requestId: this.requestId}})
      .then(response => {
        observer.next(response.data);
        observer.complete();
      })
      .catch((request) => {
        if (request.response) {
          return observer.error(request.response);
        }
        return observer.error(request.message);
      });
  }

  unsubscribe() {
    super.unsubscribe();

    if (this.aborted === false) {
      App.axios.cancel(this.requestId);
      this.aborted = true;
    }
  }
}
